<template>
<!--  TODO универсально для разных размеров (Адаптивность)-->
<!--  TODO аудио загружается при каждом монтировании-->
  <div class="audio-message">
    <div class="mr-1 ml-5">
      <span v-if="isLoading" class="spinner"></span>
      <v-icon v-else
              @click="togglePlay"
              :size="36"
              class="button-icon"
              color="#C0C2FF"
      >{{!isPlaying ? '$play' : '$pause'}}</v-icon>
    </div>
    <div class="waveform-container mr-5">
      <canvas
          v-show="!isLoading"
          ref="waveform"
          class="waveform"
          @click="seekAudio"
      ></canvas>
      <m-audio-skeleton v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import MAudioSkeleton from "@/components/widgets/Audio/m-audio-skeleton.vue";
import {mapActions} from "vuex";

export default {
  name: 'm-audio-player',
  components: {MAudioSkeleton},
  props: {
    audioSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPlaying: false,
      audio: null,
      waveformData: [],
      animationId: null,
      isLoading: true,
    }
  },
  mounted() {
    this.audio = new Audio(this.audioSrc)
    this.audio.crossOrigin = "anonymous"

    this.audio.onplay = () => {
      this.isPlaying = true
      this.animateWave()
    }
    this.audio.onpause = () => {
      this.isPlaying = false
      cancelAnimationFrame(this.animationId)
    }
    this.audio.onended = () => {
      this.isPlaying = false
      cancelAnimationFrame(this.animationId)
      this.drawWaveform(1)
    }

    this.generateWaveform()
  },
  methods: {
    ...mapActions({
      GET: 'customRequests/GET'
    }),
    togglePlay() {
      if (this.isPlaying) {
        this.audio.pause()
      } else {
        this.audio.play()
      }
    },
    async generateWaveform() {
      try {
        const response = await this.GET({
          path: this.audioSrc,
          responseType: 'arraybuffer'
        })
        const arrayBuffer = response.data
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
        const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer)

        const rawData = audioBuffer.getChannelData(0)
        const samples = 55
        const blockSize = Math.floor(rawData.length / samples)
        const waveform = []

        for (let i = 0; i < samples; i++) {
          let sum = 0
          for (let j = 0; j < blockSize; j++) {
            sum += Math.abs(rawData[i * blockSize + j])
          }
          waveform.push(sum / blockSize)
        }

        this.waveformData = waveform
        this.drawWaveform()
        this.isLoading = false
      } catch (err) {
        console.error('Ошибка:', err)
      }
    },
    drawWaveform(progress = 0) {
      const canvas = this.$refs.waveform
      if (!canvas || !this.waveformData.length) return

      const ctx = canvas.getContext('2d')
      const width = canvas.width = 330
      const height = canvas.height = 160
      ctx.clearRect(0, 0, width, height)

      const barWidth = 3
      const gap = 4
      const step = barWidth + gap
      const maxBars = Math.floor(width / step)

      const totalBars = this.waveformData.length
      const startIndex = totalBars > maxBars ? totalBars - maxBars : 0

      const playedBars = progress * totalBars

      const playedColor = { r: 192, g: 194, b: 255 }  // #8486D3
      const baseColor = { r: 166, g: 173, b: 181 }    // #A6ADB5

      function drawRoundedRect(ctx, x, y, width, height, radius) {
        ctx.beginPath()
        ctx.moveTo(x + radius, y)
        ctx.lineTo(x + width - radius, y)
        ctx.arcTo(x + width, y, x + width, y + radius, radius)
        ctx.lineTo(x + width, y + height - radius)
        ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius)
        ctx.lineTo(x + radius, y + height)
        ctx.arcTo(x, y + height, x, y + height - radius, radius)
        ctx.lineTo(x, y + radius)
        ctx.arcTo(x, y, x + radius, y, radius)
        ctx.closePath()
        ctx.fill()
      }

      for (let i = startIndex; i < totalBars; i++) {
        const indexOnCanvas = i - startIndex
        const value = this.waveformData[i]
        const barHeight = value * height * 2.5
        const x = indexOnCanvas * step
        const y = (height - barHeight) / 2

        // t = прогресс от 0 (не проиграно) до 1 (полностью проиграно)
        const t = Math.min(1, Math.max(0, playedBars - i))

        // Интерполяция цвета
        const r = Math.round(baseColor.r + (playedColor.r - baseColor.r) * t)
        const g = Math.round(baseColor.g + (playedColor.g - baseColor.g) * t)
        const b = Math.round(baseColor.b + (playedColor.b - baseColor.b) * t)

        ctx.fillStyle = `rgb(${r}, ${g}, ${b})`

        drawRoundedRect(ctx, x, y, barWidth, barHeight, 3)
      }
    },
    animateWave() {
      this.drawWaveform(this.audio.currentTime / this.audio.duration)
      this.animationId = requestAnimationFrame(this.animateWave)
    },
    seekAudio(event) {
      const canvas = this.$refs.waveform
      const rect = canvas.getBoundingClientRect()
      const clickX = event.clientX - rect.left

      const barWidth = 3
      const gap = 4
      const step = barWidth + gap
      const maxBars = Math.floor(canvas.width / step)
      const totalBars = this.waveformData.length

      const startIndex = totalBars > maxBars
          ? totalBars - maxBars
          : 0

      const indexOnCanvas = Math.floor(clickX / step)
      const waveformIndex = startIndex + indexOnCanvas

      if (waveformIndex >= totalBars) return

      const percent = waveformIndex / totalBars
      this.audio.currentTime = percent * this.audio.duration
      this.drawWaveform(percent)
    }
  },
  beforeUnmount() {
    cancelAnimationFrame(this.animationId)
  },
}
</script>

<style scoped>
.audio-message {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 10px;
  background:var(--bg);
  border-radius: 6px;
}

.waveform-container {
  position: relative;
  width: 330px;
  height: 80px;
}

.waveform {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 5px solid #d3d6db;
  border-top: 5px solid var(--basic-grey);
  border-radius: 50%;
  animation: spin 1.3s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
<style>
.button-icon.v-icon.v-icon::after{
  background-color: unset;
}
</style>
